import langTranslate from 'locale'
export const NUM = 5
const skipArray = ['qa2.cleartrip.sa', 'qa2.cleartrip.ae', 'qa2.cleartrip.com']
// export let DOMAIN =
//     process.env.CT_ENV === 'development'
//         ? 'http://localhost:3031'
//         : skipArray.indexOf(window.location.hostname) >= 0 ? process.env.CT_PUBLIC_PLATFORM_URL : window.location.origin || 'https://platform.cleartrip.com/aircon-api'
export let DOMAIN =
    process.env.CT_ENV === 'development'
        ? 'http://localhost:3031'
        : window.location.origin || 'https://www.cleartrip.com'
export let HOSTNAME = window.location.hostname || 'www.cleartrip.com'
export let ANALYTICS_DOMAIN = process.env.CT_ANALYTICS_BASE_HOST_URL || 'https://analytics.cltpstatic.com'
export const NON_ARABIC_DOMAINS = ['IN', 'ZA', 'EU']
export const CT_ENV = process.env.CT_ENV
// One out of 3 params can be provided from ['cheap','normal','cfw']
export const DEFAULT_FARE_CARD_SELECTED = 'cheap'
export let ORIGIN_DOMAIN =
    process.env.CT_ENV === 'development'
        ? 'http://localhost:3031'
        : window.location.origin || 'https://www.cleartrip.com'
let male = langTranslate('Male')
let female = langTranslate('Female')
let maleObject = {
    adult: 'Mr',
    child: 'Mstr',
    infant: 'Mstr'
}
let femaleObject = {
    adult: 'Ms',
    child: 'Miss',
    infant: 'Miss'
}
export const GENDER_TITLE_MAPPING = {
    Others: {
        adult: 'Mr',
        child: 'Mstr',
        infant: 'Mstr'
    },
    Male: maleObject,
    Female: femaleObject
}
if (langTranslate('Male') != 'Male') {
    GENDER_TITLE_MAPPING[male] = maleObject
    GENDER_TITLE_MAPPING[female] = femaleObject
}

export const TITLE_GENDER_MAPPING = {
    Mr: 'Male',
    Mstr: 'Male',
    Ms: 'Female',
    Miss: 'Female'
}
// switch (process.env.CT_ENV) {
//     case 'staging':
//         DOMAIN = 'https://qa2.cleartrip.com'
//         break
//     case 'production':
//         DOMAIN = 'https://www.cleartrip.com'
//         break
//     case 'development':
//         DOMAIN = 'http://localhost:3031'
//         break
//     default:
//         DOMAIN = 'https://www.cleartrip.com'
// }
